import AlertsEngine from '@/lib/AlertsEngine'
import api from '@/api'
import types from './notificationsTypes.js'

export default {
  async getNotifications(context) {
    try {
      const ELEMENTS_TO_GET = 10
      const organizationId = context?.rootGetters?.organizationId

      context.dispatch('showLoader')
      context.commit(types.CLEAR_NOTIFICATIONS)

      const response = await api.notification.getAll({
        organizationId,
        limit: ELEMENTS_TO_GET,
      })

      const notifications = response?.data

      context.commit(types.ADD_BULK_NOTIFICATIONS, {
        notifications: notifications,
      })

      context.commit(types.SET_LAST_NOTIFICATION_ID, {
        lastNotificationId:
          notifications?.length > 0 ? notifications[0]._id : null,
      })

      return notifications
    } catch (err) {
      console.log(err)
    }
  },

  addNotificationToAlerts(context, notification) {
    context.commit(types.ADD_NOTIFICATION_TO_ALERTS, { notification })
  },

  async pollNotifications(context, payload) {
    try {
      const organizationId = context?.rootGetters?.organizationId

      const lastNotificationId = context.state.lastNotificationId
      if (!lastNotificationId)
        return await context.dispatch('getUserNotifications', payload)

      const result = await api.notification.getUnreadNotificationStatus({
        organizationId,
        lastNotificationId,
      })

      const { hasNewNotifications } = result.data
      if (hasNewNotifications) {
        return await context.dispatch('getUserNotifications', payload)
      }
    } catch (error) {
      console.log(error)
    }
  },

  async getUserNotifications(context, payload) {
    const organizationId = context?.rootGetters?.organizationId
    const { localStorage, limit } = payload
    const alertsEngine = new AlertsEngine(localStorage)

    const notificationResults = await api.notification.getAll({
      organizationId,
      limit,
    })

    context.commit(types.CLEAR_NOTIFICATIONS)
    const notifications = notificationResults.data || []

    context.commit(types.SET_LAST_NOTIFICATION_ID, {
      lastNotificationId: notifications[0]?._id,
    })

    notifications.forEach(notification => {
      context.commit(types.ADD_NOTIFICATION, {
        notification: notification,
      })

      if (alertsEngine.hasBeenShown(notification._id)) return

      context.commit(types.ADD_NOTIFICATION_TO_ALERTS, { notification })
      alertsEngine.markAsShown(notification._id)
    })
  },

  dismissNotification(context, notification) {
    context.commit(types.REMOVE_NOTIFICATION_FROM_ALERTS, {
      notification: notification,
    })
  },

  async markNotificationAsRead(context, payload) {
    try {
      const organizationId = context?.rootGetters?.organizationId
      const response = await api.notification.markAsRead({
        organizationId,
        notificationIds: [payload.notificationId],
      })

      const notification = response?.data?.[0] ?? null

      context.commit(types.REPLACE_NOTIFICATION, {
        notification,
      })

      return notification
    } catch (err) {
      console.log(err)
    }
  },

  async markAllNotificationsAsRead(context) {
    try {
      const organizationId = context?.rootGetters?.organizationId
      const notifications = context.state.notifications
      const notificationIds = notifications.map(n => n._id)

      await api.notification.markAsRead({ organizationId, notificationIds })

      context.commit(types.MARK_ALL_NOTIFICATIONS_AS_READ, {
        notifications,
      })
    } catch (err) {
      console.log(err)
    }
  },
}
